import styled from '@emotion/styled'

export const SFakeProgressBar = styled.div`
  height: 8px;
  width: 240px;
  border-radius: 6px;
  background-color: var(--c-blue100);
`

export const SFilledBar = styled.div<{
  duration: number
  percentage: number
}>`
  height: 100%;
  width: ${({ percentage }) => percentage}%;
  background-color: var(--c-blue500);
  transition: ${({ duration }) => duration / 1000}s ease;
  border-radius: 6px;
`
